import React, { useEffect, useState } from 'react'
import ChatContent from './ChatContent';
import ChatMenu from './ChatMenu';
import { resetUnreadCount, selectChatList, selectChatFilterOptions, changeConversationActivityStatus, changeConversationMessageType, startManualChat, loadMoreChatList } from 'utils/redux/actions/chatActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import InnerAppLayout from 'pages/inner-app-layout';

const Chat = props => {

	useEffect(() => {
		var params = { 
		}
		props.selectChatListAction(params);
	}, []); 
	const [activeNumber,setActiveNumber] = useState(""); 

	const onChangeChatIndex =(number)=>{
		setActiveNumber(number);
	}

	// Handler to reset active chat (triggers full re-render)
	const handleChatListRefresh = () => {
		setActiveNumber("");
	}

	return (
		<div className="chat">
			<Helmet title="Mesaj Listesi" />
			<InnerAppLayout
				sideContent={<ChatMenu {...props} activeNumber={activeNumber} onChangeChatIndex={onChangeChatIndex} onChatListRefresh={handleChatListRefresh} />}
				mainContent={<ChatContent {...props} activeNumber={activeNumber} onChatListRefresh={handleChatListRefresh} />}
				sideContentWidth={450}
				sideContentGutter={false}
				border
				pageHeader={false}
			/>
		</div>
	)
}


function mapStateToProps(state) {

	return {
		isLoading: state.chatReducer.isLoading,
		isLoadingMore: state.chatReducer.isLoadingMore,
		hasMore: state.chatReducer.hasMore,
		chatList: state.chatReducer.chatList,
		hasError: state.chatReducer.hasError,
		errorMessage: state.chatReducer.errorMessage,
		filterOptions: state.chatReducer.filterOptions,
		filterOptionsLoading: state.chatReducer.filterOptionsLoading,
		filterOptionsError: state.chatReducer.filterOptionsError,
		filterOptionsErrorMessage: state.chatReducer.filterOptionsErrorMessage,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		selectChatListAction: bindActionCreators(selectChatList, dispatch),
		resetUnreadCountactions: bindActionCreators(resetUnreadCount, dispatch),
		selectChatFilterOptionsAction: bindActionCreators(selectChatFilterOptions, dispatch),
		changeConversationActivityStatusAction: bindActionCreators(changeConversationActivityStatus, dispatch),
		changeConversationMessageTypeAction: bindActionCreators(changeConversationMessageType, dispatch),
		startManualChatAction: bindActionCreators(startManualChat, dispatch),
		loadMoreChatListAction: bindActionCreators(loadMoreChatList, dispatch),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
